import { useTranslation } from 'react-i18next';
import { percentOf } from './laneModel';
import styles from './Timeline.module.css';

/**
 * The "now" indicator across the lane, painted under the time blocks. The day view's line also
 * carries a "Now" label at its right end; the narrow week lanes do not (`showLabel` false).
 */
export function NowLine({
  nowMin,
  dayStartMin,
  showLabel = false,
}: {
  nowMin: number;
  dayStartMin: number;
  showLabel?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div
      className={styles.nowLine}
      style={{ top: `${percentOf(nowMin, dayStartMin)}%` }}
      data-testid="now-line"
    >
      {showLabel ? (
        <span className={styles.nowLabel} data-testid="now-line-label">
          {t('draft.now')}
        </span>
      ) : null}
    </div>
  );
}
